import classNames from 'classnames';
import { CoreUIContext } from './provider';

export const DialogContainer = <TButton extends string>({
  title,
  buttons,
  onClose = () => true,
  className,
  children
}: React.PropsWithChildren<{
  title: string;
  /**
   * The list of buttons, where each button is either a string with its text or an array of [text, buttonElementClass]
   */
  buttons: readonly (TButton | [TButton, string])[];
  /**
   * Called when the dialog closes. Should return false to indicate that the dialog cannot be closed at this time, or true otherwise.
   */
  onClose?: (button: TButton) => boolean;
  className?: string;
}>) => (
  <CoreUIContext.Consumer>
    {({ _closeCurrentDialog }) => (
      <>
        <div className={classNames('flex-1 overflow-y-auto p-4 pb-0', className)}>
          <h1 className='mb-6 text-3xl select-none'>{title}</h1>
          {children}
        </div>
        <div className='flex items-center justify-end p-4'>
          {buttons
            .map(b => (typeof b === 'string' ? { text: b } : { text: b[0], className: b[1] }))
            .map((b, i) => (
              <button
                className={classNames(b.className ?? 'secondary', 'instant-touch', i !== 0 && 'ml-2')}
                key={b.text}
                onClick={() => {
                  try {
                    if (onClose(b.text)) _closeCurrentDialog();
                  } catch {
                    _closeCurrentDialog();
                  }
                }}
              >
                {b.text}
              </button>
            ))}
        </div>
      </>
    )}
  </CoreUIContext.Consumer>
);
